module.exports = __webpack_public_path__ + "static/media/severity-green.d05d92cb.svg";